export default __webpack_public_path__ + "928329048c4412e67142fb2aaa89ccdd.svg";